export default "__VITE_ASSET__D4f_Ufdy__"